import { Box, Dialog, DialogContent, IconButton } from '@mui/material';
import Button from '@components/atoms/Button';
import { IconMoon } from '@components/atoms/Icon/IconMoon.jsx';
import React from 'react';

export const ConfirmationModal = ({
  open,
  onClose,
  title,
  content,
  subContent,
  cancelButtonTitle,
  agreeButtonTitle,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl">
      <>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '16px 16px 0 16px',
            alignItems: 'center',
            fontSize: '24px',
          }}
        >
          <p>{title}</p>
          <IconButton onClick={onClose}>
            <IconMoon icon={'close'} />
          </IconButton>
        </Box>
        <DialogContent>
          <Box>{content}</Box>
          {subContent && <Box>{subContent}</Box>}
        </DialogContent>
        <Box
          sx={{
            padding: '10px 0px 30px 16px',
            '@media (max-width: 576px)': {
              paddingRight: '16px',
            },
          }}
        >
          <Button
            variant="outlined"
            customColor={'#004570'}
            border={'2px solid #004570'}
            hoverBorder={'2px solid #004570'}
            backgroundColor={'#E1F8FF'}
            onClick={() => onClose('cancel')}
          >
            {cancelButtonTitle}
          </Button>
          <Button
            variant="contained"
            marginLeft={'1.5rem'}
            customColor={'#004570'}
            disableElevation
            onClick={() => onClose('agree')}
          >
            {agreeButtonTitle}
          </Button>
        </Box>
      </>
    </Dialog>
  );
};
